import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import Captcha from "demos-react-captcha";
import Select from "react-select";
import InputMask from "react-input-mask";

import API from "../../../../api/baseUrl";
import { serialize, original } from "../../../../functions/helper";
import config from "../../../../config.json";
import { enDate, faDate, customDayDate } from "../../../../functions/date";
import FastVisitModal from "../../../../components/modal/FastVisitModal";
import Loading from "../../../../components/loading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const dateMask = {
  mask: "9999/99/99",
  maskChar: "_",
  alwaysShowMask: false,
  formatChars: {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  },
  permanents: [2, 5],
};

export default function FastVisit() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const Login_User_Token = localStorage.getItem("user_login_token");
  const Login_User_cp = localStorage.getItem("user_login_cp");

  const { state } = useLocation();

  const [data, setData] = useState({
    initialCode: state?.nationalCode,
    phoneNumber: state?.phoneNumber,
    fday: faDate,
    tday: customDayDate(7),
    desc: "",
    c_week: { label: "", value: "" },
    cs: { label: "", value: "" },
    cp_expert: { label: "", value: "" },
  });
  const [showModal, setShowModal] = useState(false);
  const [services, setServices] = useState([]);
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    if (!state?.nationalCode || !state?.phoneNumber) history.push("/");
    else fetchServiceData(Login_User_Token, Login_User_cp);
  }, []);

  useEffect(() => {
    if (!data.fday.includes("_") && !data.tday.includes("_") && data.cs.value)
      fetchExpertData();
  }, [data.fday, data.tday, data.cs, ]);

  // console.log(state);

  const fetchExpertData = async () => {
    try {
      setLoading(true);
      const resExpert = await API.post(
        serialize({
          id: 1711,
          sp_param: `'${localStorage.getItem(
            "user_login_token"
          )}','${localStorage.getItem("user_login_cp")}','0','0','0','0','0','${
            data.fday
          }','${data.tday}','${data?.cs?.value}','0'`,
          Login_User_Token: localStorage.getItem("user_login_token"),
          Login_User_cp: localStorage.getItem("user_login_cp"),
        })
      );

      let resExpertParse = original(resExpert.data, false);

      let expertArr = [];

      resExpertParse.map((item) => {
        expertArr.push({
          label: `${item.n_expert} (${item.cp_expert})`,
          value: item.cp_expert,
        });
      });
      setLoading(false);

      setExperts(expertArr);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServiceData = async (token, cp) => {
    try {
      const resService = await API.post(
        serialize({
          id: 1581,
          sp_param: cp,
          Login_User_Token: token,
          Login_User_cp: cp,
        })
      );

      let resServiceParse = original(resService.data, false);

      let serviceArr = [];
      resServiceParse.map((item) => {
        serviceArr.push({ label: `${item.ns} (${item.cs})`, value: item.cs });
      });

      setServices(serviceArr);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenModal = () => {
    if (
      !data.initialCode ||
      !data.phoneNumber ||
      !data.fday ||
      !data.tday ||
      !data.cs.value ||
      !data.cp_expert.value
    ) {
      swal("همه ی موارد الزامی می باشد", { button: "متوجه شدم" });
    } else {
      setShowModal(true);
    }
  };

  return (
    <div
      className="fast-visit-page"
      style={{
        background: `linear-gradient(45deg,${
          config.auth_back_color_1
            ? config.auth_back_color_1
            : "rgba(86, 0, 110, 1)"
        } 10%,${
          config.auth_back_color_2
            ? config.auth_back_color_2
            : "rgba(33, 150, 243, 1)"
        } 100%)`,
      }}
    >
      <div className="fast-visit-page__box">
        {/* <h1>{config.header ? config.header : "NeedSoft"}</h1> */}
        <h2 className="fast-visit-page__title">
          {config.fast_visit_insert ? config.fast_visit_insert : "insert visit"}
        </h2>
        <div className="fast-visit-page__desc">
          {config.fast_visit_description_text.split("\n").map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </div>
        <form className="fast-visit-page__form">
          {/* <div className="text-input">
						<input
							type="text"
							id="username"
							className="text-input__input ltr"
							value={data.initialCode}
							readOnly
							placeholder={
								config.fast_visit_input_initial_code
									? config.fast_visit_input_initial_code
									: "initial code"
							}
						/>
					</div>

					<div className="text-input">
						<input
							type="text"
							id="text"
							className="text-input__input ltr"
							readOnly
							value={data.phoneNumber}
							placeholder={
								config.register_input_phone
									? config.register_input_phone
									: "phone"
							}
						/>
					</div> */}

          <div className="text-input">
            <InputMask
              {...dateMask}
              value={data.fday}
              className="text-input__input ltr"
              onChange={(e) => setData({ ...data, fday: e.target.value })}
              placeholder={
                config.fast_visit_input_sdate
                  ? config.fast_visit_input_sdate
                  : "start date"
              }
            />
          </div>

          <div className="text-input">
            <InputMask
              {...dateMask}
              value={data.tday}
              className="text-input__input ltr"
              onChange={(e) => setData({ ...data, tday: e.target.value })}
              placeholder={
                config.fast_visit_input_edate
                  ? config.fast_visit_input_edate
                  : "end date"
              }
            />
          </div>

          <div className="text-input">
            <Select
              options={services}
              //   value={options[0]}
              //   isLoading={userLoading}
              onChange={(e) => {
                setData({
                  ...data,
                  cs: { label: e.label, value: e.value },
                });
              }}
              //   onInputChange={(e) => handleUserInputChange(e)}
              loadingMessage={() => "لطفا صبر کنید"}
              // onKeyDown={handleFindUser}
              placeholder={
                config.fast_visit_input_cs
                  ? config.fast_visit_input_cs
                  : "service code"
              }
              // isClearable={true}
            />
          </div>

          <div className="text-input">
            <Select
              options={experts}
              //   value={options[0]}
              //   isLoading={userLoading}
              onChange={(e) => {
                setData({
                  ...data,
                  cp_expert: { label: e.label, value: e.value },
                });
              }}
              //   onInputChange={(e) => handleUserInputChange(e)}
              loadingMessage={() => "لطفا صبر کنید"}
              // onKeyDown={handleFindUser}
              placeholder={
                config.fast_visit_input_expert
                  ? config.fast_visit_input_expert
                  : "expert code"
              }
              // isClearable={true}
            />
          </div>

          <div className="text-input">
            <textarea
              value={data.desc}
              className="text-input__textarea"
              onChange={(e) => setData({ ...data, desc: e.target.value })}
              placeholder={
                config.fast_visit_description
                  ? config.fast_visit_description
                  : "description"
              }
            ></textarea>
          </div>

          {/* <div style={{ width: "100%" }}>
            {config.show_fast_visit_captcha === 1 && (
              <Captcha onChange={onChangeCaptcha} placeholder="کد تصویر" />
            )}
          </div> */}

          <div className="button-container">
            {/* {!showForm ? (
              <button
                className="fast-visit-page__form_btn"
                onClick={handleLoginOrSignup}
              >
                {config.fast_visit_button_text_1
                  ? config.fast_visit_button_text_1
                  : "next"}
              </button>
            ) : ( */}
            <button
              type="button"
              className="fast-visit-page__form_btn"
              onClick={handleOpenModal}
            >
              {config.fast_visit_insert_button_text
                ? config.fast_visit_insert_button_text
                : "submit"}
            </button>
            {/* )} */}
            <div className="fast-visit-page__form_links">
              <Link to={{ pathname: "/visit/info", state }}>مرحله قبل</Link>
            </div>
          </div>
        </form>
        <div className="fast-visit-page__box_footer">
          <span>{enDate}</span>
        </div>
      </div>

      <FastVisitModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        data={data}
      />
      {loading && <Loading />}
    </div>
  );
}
